import initializeOcpsPolicyStore from "./initializeOcpsPolicyStore";
import { getItem, itemExists } from "owa-local-storage";
import { USER_OCPS_POLICY_STORE } from "./constants";
import type { OcpsPolicyStore } from "../store/schema/OcpsPolicyStore";
import { updateOcpsLocalStorage } from "./updateOcpsLocalStorage";
import { logGreyErrorFromAccounts } from "owa-account-analytics";
import { tryGetGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";

export function shouldRetryFetchPoliciesAndSetStore(): void {
    const maxRetries = 1;
    if (itemExists(window, USER_OCPS_POLICY_STORE)) {
        const ocpsPolicyStore: OcpsPolicyStore = JSON.parse(getItem(window, USER_OCPS_POLICY_STORE) ?? "");
        let retryCount = ocpsPolicyStore.retryFetchCount ?? 0;
        
        if (retryCount < maxRetries) {
            try {
                retryCount++;
                ocpsPolicyStore.retryFetchCount = retryCount;
                updateOcpsLocalStorage(ocpsPolicyStore, "RETRY");
                
                // Fetch the store here
                initializeOcpsPolicyStore("RetryFetchPoliciesAndSetStore");
            }
            catch (error) {
                logGreyErrorFromAccounts("FetchPoliciesAndSetStore_RetryFailed", tryGetGlobalSettingsAccountMailboxInfo(), error instanceof Error ? error : undefined);
            }
        }
    }
}
